import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'
import sv from './locales/sv.json'

const savedLanguage = localStorage.getItem('language') || 'en'

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    sv: { translation: sv },
  },
  lng: savedLanguage,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
})

// Keep <html lang> in sync with the active language for screen readers.
if (typeof document !== 'undefined') {
  document.documentElement.lang = savedLanguage
  i18n.on('languageChanged', (lng) => {
    document.documentElement.lang = lng
  })
}

export const changeLanguage = (lng: string) => {
  void i18n.changeLanguage(lng)
  localStorage.setItem('language', lng)
}

export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'sv', name: 'Svenska', flag: '🇸🇪' },
]

export default i18n
